import { UseFormReturn } from "react-hook-form";

import { useGlobalData } from "../../GlobalDataProvider";
import { IModuleRound, useRound } from "../../../modules/roundHandler";
import { bfv_J5 } from "../../../modules/Beräkningsmoduler/BFV_J5";
import { IGlobalData } from "../../../types/globalData";
import Funktionskontroller from "./Funktionskontroller";
import BFLNote from "./BFLNote";
import ErrorInfo from "./ErrorInfo";
import DebugInfo from "./DebugInfo";
import { Card } from "react-bootstrap";

interface IProps {
  module: IModuleRound;
  formHook: UseFormReturn;
}

const BFV_J5 = ({ module, formHook }: IProps) => {
  const roundHandler = useRound();
  const globalData = useGlobalData();

  const bimHandler = roundHandler.getBimHandler();

  const formData: any = formHook.getValues();
  const bm = bfv_J5().getResult(module, bimHandler, roundHandler, globalData.data as IGlobalData, formData);
  const funktionsKontroller = bm.funktionsKontroller;

  const systemText = globalData.beräkningsflikarText.beskr_BFV_J5;
  return (
    <>
      <Card className="mb-3">
        <Card.Header>{systemText?.title}</Card.Header>
        <Card.Body>
          {/* Funktionskontroll för Vattenburet sekundärvärmesystem. Regleravvikelse framledning. */}
          <div dangerouslySetInnerHTML={{ __html: systemText?.body as string }} />
          <Funktionskontroller bfName="BFV_J5" formHook={formHook} funktionsKontroller={funktionsKontroller} />
          <BFLNote formHook={formHook} />
          <ErrorInfo info={bm.error} />
          <DebugInfo info={bm.debug} />
        </Card.Body>
      </Card>
    </>
  );
};

export default BFV_J5;
